module.exports = __webpack_public_path__ + "static/media/sparrow-chirping.3e7b1ef3.gif";